import { showModal } from '@redux/modal/modal-dispatcher';

export const MENU_ADMIN_ALLOWED_ROLES = ['boadmin', 'admin'];

export const MENU_ACTIONS = {
    signup: () => {
        showModal('signup');
    },

    login: () => {
        showModal('login');
    },

    logout: () => {
        showModal('logout');
    },
};
